module.exports = __webpack_public_path__ + "static/media/menuflor.b2970a6f.jpg";